import p from "./highrise1431.mjs";
import h from "./highrise1763.mjs";
import r from "./highrise1764.mjs";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.__data__ = new p(); ++o < a; )
    this.add(t[o]);
}
e.prototype.add = e.prototype.push = h;
e.prototype.has = r;
export {
  e as default
};
